// src/components/Apm/Contact/Contacts.js

import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useMediaQuery, useTheme } from '@mui/material';

import { getContacts } from '../../../redux/slices/contactSlice';
import { columnsContacts } from '../Tables/Columns/columnsContacts';
import TableSimple from '../Tables/TableSimple';

const MOBILE_COLUMN_IDS = new Set(['companyname', 'countrycodepost']);

const Contacts = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const theme = useTheme();

  const smMediaDown = useMediaQuery(theme.breakpoints.down('sm'));

  const { contacts = [], statusContacts = null } = useSelector((state) => state.contactSlice ?? {});

  useEffect(() => {
    if (contacts.length === 0 && statusContacts === null) {
      dispatch(getContacts());
    }
  }, [contacts.length, dispatch, statusContacts]);

  const updatedColumns = useMemo(() => {
    const columns = columnsContacts();

    if (!smMediaDown) {
      return columns;
    }

    return columns.filter((column) => MOBILE_COLUMN_IDS.has(column.id));
  }, [smMediaDown]);

  return (
    <TableSimple
      resource="clients"
      columns={updatedColumns}
      popupTitle={t('popup.title.client_details')}
      data={contacts}
      addButtonText={t('button.add_client')}
    />
  );
};

export default Contacts;
